module.exports = __webpack_public_path__ + "img/logo-presse-rude-baguette_200x200.21293126.jpeg";